import React, { useState, useEffect } from 'react';
import styles from './styles.module.scss';
import { trackCallButtonClick, trackAppDownloadClick } from '../../utils/tracking';

interface SuccessSlideProps {
  mongoId?: string;
  phone?: string;
}

const COUNTDOWN_SECONDS = 10 * 60; // 10:00
const TIMER_RADIUS = 54;
const TIMER_CIRCUMFERENCE = 2 * Math.PI * TIMER_RADIUS;

function formatCountdown(totalSeconds: number): string {
  const safe = Math.max(0, totalSeconds);
  const minutes = Math.floor(safe / 60);
  const seconds = safe % 60;
  return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
}

/**
 * Slide di successo dopo l'invio del form
 */
const SuccessSlide: React.FC<SuccessSlideProps> = ({
  mongoId,
  phone,
}) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [secondsLeft, setSecondsLeft] = useState(COUNTDOWN_SECONDS);

  useEffect(() => {
    const id = window.setInterval(() => {
      setSecondsLeft((prev) => {
        if (prev <= 1) {
          window.clearInterval(id);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => window.clearInterval(id);
  }, []);

  const progress = secondsLeft / COUNTDOWN_SECONDS;
  const strokeDashoffset = TIMER_CIRCUMFERENCE * (1 - progress);

  const handleCallClick = () => {
    trackCallButtonClick();
  };

  const handleAppDownloadClick = () => {
    trackAppDownloadClick();
  };


  return (
    <div className={styles.successSlide}>
      <p className={styles.countdownLabel}>Ti chiamiamo entro</p>

      <div className={styles.countdownRing} aria-live="polite" aria-atomic="true">
        <svg className={styles.countdownSvg} viewBox="0 0 120 120" aria-hidden="true">
          <circle
            className={styles.countdownTrack}
            cx="60"
            cy="60"
            r={TIMER_RADIUS}
            fill="none"
          />
          <circle
            className={styles.countdownProgress}
            cx="60"
            cy="60"
            r={TIMER_RADIUS}
            fill="none"
            strokeDasharray={TIMER_CIRCUMFERENCE}
            strokeDashoffset={strokeDashoffset}
          />
        </svg>
        <span className={styles.countdownTime}>{formatCountdown(secondsLeft)}</span>
      </div>

      <div className={styles.orSeparator}>
        <span className={styles.orLine} />
        <span className={styles.orText}>Oppure</span>
        <span className={styles.orLine} />
      </div>

      <div className={styles.successCtaBar}>
        <a
          href="tel:00393476331490"
          className={styles.btnCallNow}
          onClick={handleCallClick}
        >
          Chiamaci Ora
        </a>
      </div>

      <h3 className={styles.successMainTitle}>
        Approfitta dei Bonus e risparmia
      </h3>

      {mongoId && (
        <a
          href={`https://app.enpal.it/login?payload=${btoa(phone || '')}`}
          className={styles.appCta}
          target="_blank"
          rel="noopener noreferrer"
          onClick={handleAppDownloadClick}
        >
          Scarica l'app per scoprire di più sui bonus
        </a>
      )}
    </div>
  );
};

export default SuccessSlide;
